import { PartnerConnector } from '@generated/gql/graphql';
import { INTRODUCED_BY, ReferralFieldFormValues } from '@src/types/attribution';
import {
  ReferrerTrackingContext,
  ReferrerTypeTracking,
} from '@src/types/tracking';

const parseReferrerContext = (
  values: Partial<ReferralFieldFormValues>,
  connectors: Nullable<PartnerConnector[]>
): Nullable<ReferrerTrackingContext> => {
  const { introducedBy, customerReferral, partnerReferral, connectorReferral } =
    values;

  switch (introducedBy) {
    case INTRODUCED_BY.CUSTOMER: {
      if (!customerReferral) {
        return null;
      }
      return {
        referrerType: ReferrerTypeTracking.CUSTOMER,
        referrerDetails: customerReferral,
      };
    }

    case INTRODUCED_BY.PARTNER: {
      if (!partnerReferral) {
        return null;
      }
      return {
        referrerType: ReferrerTypeTracking.PARTNER,
        referrerDetails: partnerReferral,
      };
    }

    case INTRODUCED_BY.CONNECTOR: {
      if (!connectorReferral) {
        return null;
      }

      const connector = connectors?.find(
        (connector) => connector.id === connectorReferral
      );

      if (!connector) {
        return {
          referrerType: ReferrerTypeTracking.CONNECTOR,
          referrerDetails: connectorReferral,
        };
      }

      return {
        referrerType: ReferrerTypeTracking.CONNECTOR,
        referrerDetails: connector.shortId,
      };
    }

    default: {
      return null;
    }
  }
};

export { parseReferrerContext };
